module.exports = __webpack_public_path__ + "static/media/ebd-bco.804e54b2.svg";